module.exports = __webpack_public_path__ + "img/circle-minus.04c1373d.svg";